export default __webpack_public_path__ + "static/media/facebook.ba9e7a18.svg";